import PrimeVue from 'primevue/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

// Warm Promart: accessible orange actions, navy text, warm neutral surfaces.
export const LoyaltyPreset = definePreset(Aura, {
  semantic: {
    primary: {"50":"#fff5ed","100":"#ffead5","200":"#ffd0a8","300":"#ffaf71","400":"#ff853d","500":"#f05200","600":"#c44100","700":"#a33400","800":"#842e09","900":"#6c280c","950":"#3b1103"},
    colorScheme: {
      light: {
        primary: { color:'{primary.600}', inverseColor:'#ffffff', hoverColor:'{primary.700}', activeColor:'{primary.800}' },
        highlight: { background:'{primary.50}', focusBackground:'{primary.100}', color:'{primary.700}', focusColor:'{primary.800}' },
        surface: { 0:'#ffffff', 50:'#fdfbf5', 100:'#f7f4e6', 200:'#e7e2d6', 300:'#d1cabb', 400:'#a49e91', 500:'#79766b', 600:'#615f56', 700:'#414b51', 800:'#253f52', 900:'#123454', 950:'#0c243a' },
      },
    },
  },
  components: {
    button: { borderRadius: '6px' },
    inputtext: { borderRadius: '6px' },
    select: { borderRadius: '6px' },
    dialog: { borderRadius: '8px' },
    card: { borderRadius: '8px' },
  },
});

export const primeOptions = {
  theme: { preset: LoyaltyPreset, options: { darkModeSelector: false, cssLayer: { name: 'primevue', order: 'tailwind-base, primevue, tailwind-utilities' } } },
  locale: { aria: { close: 'ปิด', chooseDate: 'เลือกวันที่', nextPageLabel: 'หน้าถัดไป', previousPageLabel: 'หน้าก่อน', firstPageLabel: 'หน้าแรก', lastPageLabel: 'หน้าสุดท้าย', pageLabel: 'หน้า {page}' }, accept: 'ยืนยัน', reject: 'ยกเลิก', choose: 'เลือก', upload: 'อัปโหลด', cancel: 'ยกเลิก', emptyMessage: 'ไม่มีรายการ', emptySearchMessage: 'ไม่พบข้อมูล', firstDayOfWeek: 1, dayNames: ['อาทิตย์','จันทร์','อังคาร','พุธ','พฤหัสบดี','ศุกร์','เสาร์'], dayNamesShort: ['อา.','จ.','อ.','พ.','พฤ.','ศ.','ส.'], dayNamesMin: ['อา','จ','อ','พ','พฤ','ศ','ส'], monthNames: ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม'], monthNamesShort: ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.'], today: 'วันนี้', clear: 'ล้าง', dateFormat: 'dd/mm/yy' },
  ripple: true,
};

export default PrimeVue;
